import { Tabs, Typography } from 'antd';
import { useCallback, useEffect, useState } from 'react';

import { first } from 'lodash';
import styled from '@emotion/styled';

export function SpTabs(props) {
  const [tabKeys, setTabKeys] = useState('');

  const onTabClick = useCallback((ss) => {
    setTabKeys(ss);
    props?.onTabClick?.(ss);
  }, []);

  useEffect(() => {
    if (props?.currentKeys) {
      setTabKeys(props?.currentKeys);
    } else {
      const firstRecord = first(props.items);
      setTabKeys(firstRecord?.key);
    }
  }, []);

  return (
    <TabComponent {...props} defaultActiveKey={tabKeys} onTabClick={onTabClick}>
      {props?.items?.map((record) => (
        <Tabs.TabPane
          tab={<Typography.Text style={{ fontSize: 16, padding: '0 18px' }}>{record.title}</Typography.Text>}
          key={record?.key}
        >
          {record.element}
        </Tabs.TabPane>
      ))}
    </TabComponent>
  );
}

const TabComponent = styled(Tabs)({
  '.ant-tabs-content-holder': {
    padding: 0,
  },
  '.ant-tabs-tab-active': {
    '.ant-typography': {
      color: '#ff0000',
    },
  },
  '.ant-tabs-ink-bar': {
    display: 'none',
  },
});
